module.exports = __webpack_public_path__ + "f11ff70445ca613c095463f283019a87.png";